import React from "react";
import styled from "@emotion/styled";
import { Container } from "@mui/material";
import { Helmet } from "react-helmet";

import DynamicComponentLoader from "../components/DynamicComponent";

export default function OfficeSpace(props) {
  //   const { Content, Hero: HeroData = [] } = props?.data;
  return (
    <>
      <Helmet>
        <title itemProp="name" lang="en">
          The Kahanoff Centre – Office Space
        </title>
      </Helmet>
      <Container
        id="office-space"
        disableGutters
        align="center"
        maxWidth={"false"}
        sx={{ mb: { xs: "3rem", md: "7rem" } }}
        // style={{ marginBottom: "7rem" }}
      >
        <DynamicComponentWrapper>
          {props?.data?.Content?.map((block, index) => {
            return <DynamicComponentLoader key={block.Copy} theme={props?.theme} {...block} />;
          })}
        </DynamicComponentWrapper>{" "}
      </Container>
    </>
  );
}
const DynamicComponentWrapper = styled.div`
  p,
  h3 {
    // max-width: 524px;
  }
  a:not(.button) {
    color: rgba(71, 76, 85, 1);
  }

  .slick-dots {
    height: 3rem;

    display: flex !important;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 0;
    top: 0;
    ${props => props.theme.breakpoints.up("md")} {
      bottom: initial;
    }
    & > li {
      width: 16px;
      ${props => props.theme.breakpoints.up("md")} {
        width: 20px;
      }
    }
  }
`;
